<template>
  <div >
   <MediaLibraryCategoryTracksList :client_name="client_name"
    :media_library="media_library"
    
    :card_title_class="'card-title-doom-yoga'" 
    :display_tabs="true"
                  :project_btn_class="'btn-doomyoga'"
    :tab_button_class="'btn-doomyoga btn-doomyoga-secondary'"
    
    :search_input_class="'input-group-search-doomyoga'"
    :input_class="'form-control-doomyoga'"
    :btn_size_class="'btn-lg-doomyoga'" 
    :btn_variant_primary="'doomyoga-primary'"
    
    :modal_class="'modal-doom-yoga'"
    :error_validation_msg_class="'error_validation_message_p_dy'"
    :video_preview_container_class="'video-preview-container-doomyoga'"
                :add_video_btn_outline_variant="'doomyoga-danger-outline'"
                :progress_bar_class="'progress-bar-doom-yoga'"
                :vselect_class="'form-group-vselect-doomyoga'"
                :btn_submit_class="'btn-doomyoga btn-doom-yoga-submit'"
                :form_label_class="'form-label-doomyoga'"
                    
                :media_category_title_class="'media-category-title-doom-yoga'"
                :player_container_class="'player-container-dy'"
                :current_player_title_class="'current-player-title-dy'"
                :current_player_description_class="'current-player-description-dy'"
    
                :dropdown_action_class="'dropdown-actions-dy'"
                :playlist_tracks_class="'playlist-tracks-dy'"
                :dataset_data_info_class="'datasetInfoDY'"
                :dataset_pagination_class="'datasetPagerDY'"

                :playlist_item_class="'playlist-item-dy'"
                :confirm_message_class="'message-modal-dy'"
                :btn_danger_outline_class="'doomyoga-danger-outline'"
              
                :swal_confirm_button_class="'btn btn-bumblebee btn-doomyoga  btn-doomyoga-primary'"
            :swal_container_class="'swal-container-doom-yoga'"

    />
            
    <!--  :btn_variant_info="'doomyoga-info'"
                :btn_variant_delete="'doomyoga-info'"
                :category_tracks_url="'/doom_yoga/video_library/category/'"
                :btn_group_actions_class="'btn-group-actions-doomyoga'"
                :dataset_not_found_data_class="'noDataFoundDY'"
                :dataset_data_info_class="'datasetInfoDY'"
                :dataset_pagination_class="'datasetPagerDY'"

                :confirm_message_class="'message-modal-dy'"
                :btn_danger_outline_class="'doomyoga-danger-outline'"

                
                :media_gallery_class="'media-gallery-dy'"
                :card_no_found_media_class="'card-no-found-media-dy'"
                :no_found_media_text_class="'no-media-text-dy'"
                :media_card_class="'media-card-dy'"-->
  </div>
</template>

<script>
import axios from "axios";
import $ from "jquery";

import MediaLibraryCategoryTracksList from '@/components/media_components/library/CategoryTracksList.vue'

export default {
  name: "VideoLibraryCategoryVideos",
  components: { MediaLibraryCategoryTracksList },
  data() {
    return {
      client_name: "DY",
      media_library: "video_library",
  
    };
  },
  mounted() {
  },
  computed: {},
  created() {
  },
  methods: {  },
};
</script>



// WEBPACK FOOTER //
// src/components/doom_yoga/video_library/CategoryVideosList.vue